import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-close\"><path d=\"M4.954 5.661L22.632 23.34m-.293-17.679L4.66 23.34\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol